import accordion from '@/ui/templates/02-components/accordion/analytics.accordion';
import bannerNotification from '@/ui/templates/02-components/banner-notification/analytics.banner-notification';
import breadcrumb from '@/ui/templates/02-components/breadcrumb/analytics.breadcrumb';
import cardListing from '@/ui/templates/02-components/card-listing/analytics.card-listing';
import categoryListing from '@/ui/templates/02-components/category-listing/analytics.category-listing';
import contactCard from '@/ui/templates/02-components/contact-card/analytics.contact-card';
import documentDownload from '@/ui/templates/02-components/document-download/analytics.document-download';
import eventDetail from '@/ui/templates/02-components/event-detail/analytics.event-detail';
import eventsFilter from '@/ui/templates/02-components/events-filter/analytics.events-filter';
import eventsListing from '@/ui/templates/02-components/events-listing/analytics.events-listing';
import featureBlock from '@/ui/templates/02-components/feature-block/analytics.feature-block';
import fullWidthText from '@/ui/templates/02-components/full-width-text/analytics.full-width-text';
import footer from '@/ui/templates/02-components/footer/analytics.footer';
import header from '@/ui/templates/02-components/header/analytics.header';
import iconBlock from '@/ui/templates/02-components/icon-block/analytics.icon-block';
import mainNav from '@/ui/templates/02-components/subcomponents/header/_nav/analytics.nav.js';
import mediaLibrary from '@/ui/templates/02-components/media-library/analytics.media-library';
import newsArticleCard from '@/ui/templates/02-components/subcomponents/news-article-card/analytics.news-article-card.js';
import newsFilter from '@/ui/templates/02-components/news-filter/analytics.news-filter';
import opportunitiesDetail from '@/ui/templates/02-components/opportunities-detail/analytics.opportunities-detail';
import opportunitiesFilter from '@/ui/templates/02-components/opportunities-filter/analytics.opportunities-filter';
import opportunitiesListing from '@/ui/templates/02-components/opportunities-listing/analytics.opportunities-listing';
import pagination from '@/ui/templates/02-components/pagination/analytics.pagination';
import projectHeroBanner from '@/ui/templates/02-components/project-hero-banner/analytics.project-hero-banner';
import projectNotificationBanner from '@/ui/templates/02-components/project-notification-banner/analytics.project-notification-banner';
import projectProgress from '@/ui/templates/02-components/project-statusbar/analytics.project-statusbar';
import reciteMe from '@/ui/templates/02-components/recite-me/analytics.recite-me';
import rte from '@/ui/templates/02-components/rich-text-editor/analytics.rte';
import searchResults from '@/ui/templates/02-components/search-results/analytics.search-results';
import sidebarNav from '@/ui/templates/02-components/sidebar-navigation/analytics.sidebar-navigation';
import socialShare from '@/ui/templates/02-components/social-share/analytics.social-share';
import triages from '@/ui/templates/02-components/triage/analytics.triage';
import upcomingEvents from '@/ui/templates/02-components/upcoming-events-listing/analytics.upcoming-events-listing';
import tabs from '@/ui/templates/02-components/subcomponents/tabs/tabs/analytics.tabs.js';
import updateCard from '@/ui/templates/02-components/update-card/analytics.update-card';
import allUpdates from '@/ui/templates/02-components/subcomponents/all-updates/analytics.all-updates';

function init() {
  accordion();
  bannerNotification();
  breadcrumb();
  cardListing();
  categoryListing();
  contactCard();
  documentDownload();
  eventDetail();
  eventsFilter();
  eventsListing();
  featureBlock();
  fullWidthText();
  footer();
  header();
  iconBlock();
  mainNav();
  mediaLibrary();
  newsArticleCard();
  newsFilter();
  opportunitiesDetail();
  opportunitiesFilter();
  opportunitiesListing();
  pagination();
  projectHeroBanner();
  projectNotificationBanner();
  projectProgress();
  reciteMe();
  rte();
  searchResults();
  sidebarNav();
  socialShare();
  triages();
  tabs();
  upcomingEvents();
  updateCard();
  allUpdates();
}

export default init;
